<template>
  <div class="">
    <div v-if="codes.length > 0" class="mt-2">
      <div class="text-decoration-underline">Aktive Codes:</div>
      <ul>
        <li v-for="c of codes">
          <b>{{ c.title }}</b>
        </li>
      </ul>
    </div>
    <!--        <div v-else>Noch keine Codes</div>-->
  </div>
</template>

<script>
import store from '../store/store'
import * as util from '@/vendor/util'

export default {
  name: "ListEnteredCodes",
  data() {
    return {
      codes: [], //contains objects of type coupons
      iv: null,
    }
  },
  // computed: {
  //     activeCodes() {
  //         let result = [];
  //         for (let item of store.getters.cartItems) {
  //             if (item.appliedCode) {
  //                 result.push({
  //                     title: item.codeTitle,
  //                 });
  //             }
  //         }
  //         return result;
  //     }
  // },
  mounted() {
    this.initIv();
  },
  // activated() {
  //     this.initIv();
  // },
  destroyed() {
    util.clearTheInterval(this.iv);
  },
  methods: {
    initIv() {
      this.iv = setInterval(() => {
        let result = [];
        for (let item of store.getters.cartItems) {
          if (item.aaaCodeTitle) {
            result.push({
              title: item.aaaCodeTitle,
            });
          }
        }
        this.codes = result;
      }, 2000);
    }
  },

}
</script>

<style scoped lang="scss">

</style>
